<template>
  <div id="page-prices" class="container">
     <pricingtable />      
  </div>
</template>




<script>
import pricingtable from "@/components/pricingtable"
export default {
  name: "prices",
  components:{  pricingtable
  }
}


</script>